import DoohVenueTypeLevel from '@/Enums/Dooh/VenueTypeLevel.enum';
import { IDoohVenueType } from '@/Interfaces/Forecaster/Dooh.interface';
import { Dialog, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

interface IProps {
  open: boolean;
  onClose: () => void;
  venueTypes: IDoohVenueType[];
}

const fontWeight: Record<DoohVenueTypeLevel, number> = {
  [DoohVenueTypeLevel.Parent]: 700,
  [DoohVenueTypeLevel.Child]: 500,
  [DoohVenueTypeLevel.Grandchild]: 400,
};

const captionId = 'venue-types-caption';

const VenueTypeView = ({ open, onClose, venueTypes }: IProps) => {
  return (
    <Dialog maxWidth={false} open={open} onClose={onClose} aria-labelledby={captionId}>
      <TableContainer component={Paper} sx={{ overflowX: 'hidden', overflowY: 'auto' }}>
        <Table stickyHeader size='small' sx={{ width: '650px' }}>
          <caption id={captionId}>Available Venue Types</caption>
          <TableHead>
            <TableRow>
              <TableCell sx={{ paddingLeft: '10px' }}>Venue Type</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {venueTypes.map(row => (
              <TableRow key={row.enumerationId}>
                <TableCell
                  sx={{ paddingLeft: `${10 + (row.level - 1) * 15}px`, fontWeight: fontWeight[row.level] ?? 400 }}
                >
                  {row.name}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Dialog>
  );
};

export default VenueTypeView;
